// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"193":"353ffdca","653":"14eda9d9","762":"0719a998"}[chunkId] + ".chunk.css";
};